import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

class DestinationListItem extends React.Component {
  getIssueStatus() {
    const { translate, serviceSites = [] } = this.props;

    let issueCount = 0;

    serviceSites.forEach(({ issues = [] }) => {
      issues.forEach(({ ack = false }) => {
        if (!ack) {
          issueCount++;
        }
      });
    });

    if (issueCount === 0) {
      return null;
    }

    return `${issueCount} ${
      issueCount === 1
        ? translate('issue_count.one')
        : translate('issue_count.multiple')}`;
  }

  getPendingStatus() {
    const { translate, session: { isAdmin = false } } = this.props;
    const { changeOrders = [], internalStatus = '', serviceSites = [] } = this.props;

    const serviceSiteChanges = serviceSites.some((serviceSite) => {
      const { changeOrders = [], internalStatus = '' } = serviceSite;

      return changeOrders.length > 0 || internalStatus.toLowerCase() === 'ordered';
    });

    if (changeOrders.length === 0 && internalStatus.toLowerCase() !== 'ordered' && !serviceSiteChanges) {
      return null;
    }

    return isAdmin ? translate('requires_action') : translate('order_pending.singular');
  }

  renderAdditionalInfo() {
    const issueStatus = this.getIssueStatus();
    const pendingStatus = this.getPendingStatus();

    if (!issueStatus && !pendingStatus) {
      return null;
    }

    return (
      <div className="row">
        {!!issueStatus
          && (
          <div className="col-sm-12 alert-color">
            {issueStatus}
            {!!pendingStatus
              && (
              <span className="additional-info-color">
                <br />
                {pendingStatus}
              </span>
              )}
          </div>
          )}
      </div>
    );
  }

  render() {
    const {
      companyName, streetAddress, postalCode, city, additionalInfo = false, customer,
    } = this.props;
    return (
      <div className="row vertical-middle text-5 normal-color">
        <div className="col-sm-4 text-4 identifier-color">{companyName}</div>
        <div className="col-sm-4 text-4 identifier-color">{ customer !== null ? customer.name : '' }</div>
        <div className="col-sm-4">
          <div className="row">
            <div className="col-sm-12">
              {streetAddress}
              ,
            </div>
            <div className="col-sm-12">{postalCode !== '' ? `${postalCode},${city}` : city !== '' ? city : postalCode }</div>
          </div>
        </div>

        {!!additionalInfo
          && (
          <div className="col-sm-4">
            {this.renderAdditionalInfo()}
          </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const languages = locale.languages || [];

  return {
    translate: languages.length > 0 ? getTranslate(locale) : () => '',
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(DestinationListItem);
